/**
 * Гейты роутов платформенной зоны (команда Skrezo).
 *
 *   TeamRoute     — пускает только если team-контур авторизован, иначе
 *                   → /login.
 *   TeamPublicRoute — обратный: залогиненного уводит с /login на дашборд.
 *
 * Кабинет клиники (client-контур) получит свои гейты по isClientAuthedAtom
 * — та же схема, отдельный компонент, когда дойдём до кабинета.
 */

import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {useAtomValue} from 'jotai';

import {isTeamAuthedAtom} from '@atoms/auth';

export const TeamRoute = () => {
  const isAuthed = useAtomValue(isTeamAuthedAtom);
  const location = useLocation();
  if (!isAuthed) {
    return <Navigate to="/login" replace state={{from: location.pathname}} />;
  }
  return <Outlet />;
};

export const TeamPublicRoute = () => {
  const isAuthed = useAtomValue(isTeamAuthedAtom);
  if (isAuthed) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
};
